var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading"},[_c('div',[_c('i',{staticClass:"el-icon-loading"})]),_c('div',[_vm._v("努力加载中...")])])}]

export { render, staticRenderFns }